import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import SocialAuthChecker from '../../../../features/components/SocialAuthChecker'
import AdDv360Edit from '../../../../forms/DV360/AdForms/AdDv360Edit'
import AdsGallery from '../../../CampaignsSummary/AdsList/AdsGallery'
import DisapproveInternalAdModal from '../../DisapproveInternalAdModal'

import useModalManage from '../../../../hooks/useModalManage'

import { getAds, clearAds } from '../../../../modules/actions/ads'
import { selectedDV360AdAccountSelector } from '../../../../modules/selectors/adAccounts'
import { selectedPartnershipRightsHolderIdSelector } from '../../../../modules/selectors/partnerships'
import { adsSelector } from '../../../../modules/selectors/ads'

import { DV_360_PLATFORM } from '../../../../constants/selectLists/platformList'
import { LIFETIME_DATE_PRESET } from '../../../../constants/selectLists/listItemFiltersList'

const DV360AdsSection = () => {
  const dispatch = useDispatch()

  const ads = useSelector(adsSelector)
  const { id: dv360AdAccountId } = useSelector(selectedDV360AdAccountSelector)
  const partnershipRightsHolderId = useSelector(selectedPartnershipRightsHolderIdSelector)

  // pass only internal asset groups to GoogleAssetGroupsPreviewList for approval
  const filteredAds = ads.filter(({ approval_status }) => approval_status === 'pending_approval')

  const {
    isModalOpened: isDisapproveInternalAdModalOpened,
    openModalHandler: disapproveInternalAdOpenModalHandler,
    closeModalHandler: disapproveInternalAdCloseModalHandler,
    modalData: disapproveInternalAdModalData
  } = useModalManage({})

  const getInternalAdsData = useCallback(() => {
    dispatch(
      getAds(
        {
          internal: true,
          rights_holder_account_id: partnershipRightsHolderId,
          approval_status: 'pending_approval',
          date_preset: LIFETIME_DATE_PRESET
        },
        DV_360_PLATFORM
      )
    )
  }, [dispatch, partnershipRightsHolderId])

  useEffect(
    () => () => {
      dispatch(clearAds())
    },
    [dispatch]
  )

  return (
    <SocialAuthChecker
      platform={DV_360_PLATFORM}
      dataFetch={getInternalAdsData}
      adAccountId={dv360AdAccountId}
      authFailureText="Please authenticate with DV360 to retrieve the list of ads."
    >
      <AdsGallery
        adsList={filteredAds}
        noDataText="There are no ads waiting for approval."
        showDetails={true}
        showActionsDropdown={false}
        showInternalAdActionButtons
        disapproveInternalAdOpenModalHandler={disapproveInternalAdOpenModalHandler}
      />
      <AdDv360Edit />
      <DisapproveInternalAdModal
        isModalOpened={isDisapproveInternalAdModalOpened}
        modalData={disapproveInternalAdModalData}
        onClose={disapproveInternalAdCloseModalHandler}
      />
    </SocialAuthChecker>
  )
}

export default DV360AdsSection
